module.exports = __webpack_public_path__ + "public/images/bts_hero_image_1.6aedd31b42506a8aa1e0f3c1d19b1e9d.webp";